/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TimeInterval = {
    hour: 'hour',
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year'
} as const;
export type TimeInterval = typeof TimeInterval[keyof typeof TimeInterval];

